import React from "react";

export const LoginInfoContext = React.createContext({});
export const LoginUserLocationContext = React.createContext("");
